import { render, staticRenderFns } from "./ObjectLoader.vue?vue&type=template&id=69aa91d5&scoped=true&"
import script from "./ObjectLoader.vue?vue&type=script&lang=js&"
export * from "./ObjectLoader.vue?vue&type=script&lang=js&"
import style0 from "./ObjectLoader.vue?vue&type=style&index=0&id=69aa91d5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69aa91d5",
  null
  
)

export default component.exports